import toast from "react-hot-toast";
import { User } from "../types/User";

// handle logout
export const handleLogOut = () => {
  localStorage.removeItem("e-user");
};

export const getUser = (): User | null => {
  const userString = localStorage.getItem("e-user");

  if (userString && userString !== "undefined") {
    try {
      const user: User = JSON.parse(userString);
      return user;
    } catch (error) {
      console.error("Failed to parse user data:", error);
    }
  }

  return null;
};

